import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { hasOpenRegistrationEnabled, OrganizationService, SiteMembershipService } from '@se-po/shared-data-access-services'
import { map } from 'rxjs/operators'

export const openRegistrationRouteGuard: CanActivateFn = () => {
  const router = inject(Router)

  return openRegistrationEnabled().pipe(
    map((enabled) => enabled || router.createUrlTree(['user', 'registrations']))
  )
}

export const legacyRegistrationsRouteGuard: CanActivateFn = () => {
  const router = inject(Router)

  return openRegistrationEnabled().pipe(
    map((enabled) => enabled ? router.createUrlTree(['user', 'registrations', 'open']) : true)
  )
}

const openRegistrationEnabled = () => {
  const organizationService = inject(OrganizationService)
  const siteMembershipService = inject(SiteMembershipService)

  return hasOpenRegistrationEnabled(organizationService, siteMembershipService)
}
